{
  "alpha": "アルファ版",
  "alphaFeedback": "アルファ版フィードバック",
  "beta": "ベータ版",
  "betaFeedback": "ベータ版フィードバック"
}
